module.exports = __webpack_public_path__ + "static/media/7.47a3f69c.svg";